import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { ArrowLeft, ExternalLink, Quote } from "lucide-react";

export default function PaperDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);

  useEffect(() => { api.get(`/papers/${id}`).then((r) => setP(r.data)); }, [id]);

  if (!p) return <div className="min-h-screen flex items-center justify-center kb-mono text-xs text-kb-ink-muted">Loading…</div>;

  return (
    <div className="min-h-screen bg-kb-bg" data-testid="paper-detail-page">
      <Navbar />
      <article className="max-w-4xl mx-auto px-6 lg:px-10 pt-16 pb-24">
        <Link to="/publications" className="kb-mono text-xs text-kb-ink-muted hover:text-kb-primary inline-flex items-center gap-2">
          <ArrowLeft className="w-3.5 h-3.5" /> BACK TO PUBLICATIONS
        </Link>
        <div className="mt-8 kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">{p.venue} · {p.year}</div>
        <h1 className="font-serif text-4xl lg:text-5xl text-kb-ink mt-3 leading-tight">{p.title}</h1>
        <div className="mt-4 text-kb-ink-muted">{p.authors.join(" · ")}</div>

        {p.image_url && (
          <div className="mt-8 aspect-[16/8] bg-cover bg-center rounded-sm border border-slate-200" style={{ backgroundImage: `url(${p.image_url})` }} />
        )}

        <div className="mt-10 kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">ABSTRACT</div>
        <p className="mt-3 text-lg text-kb-ink leading-relaxed">{p.abstract}</p>

        <div className="mt-10 grid sm:grid-cols-3 gap-px bg-slate-200 border border-slate-200 rounded-sm overflow-hidden">
          <div className="bg-white p-4">
            <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted">Year</div>
            <div className="font-mono text-kb-primary text-lg mt-1">{p.year}</div>
          </div>
          <div className="bg-white p-4">
            <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted">Venue</div>
            <div className="text-kb-ink mt-1 text-sm">{p.venue}</div>
          </div>
          <div className="bg-white p-4">
            <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted">DOI</div>
            <div className="font-mono text-kb-ink mt-1 text-xs truncate">{p.doi || "—"}</div>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {(p.domain || []).map((d) => (
            <span key={d} className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink bg-slate-100 px-2 py-1 rounded-sm">{d}</span>
          ))}
          {(p.tags || []).map((t) => (
            <span key={t} className="kb-mono text-[10px] uppercase tracking-wider text-kb-primary bg-kb-primary/5 px-2 py-1 rounded-sm">{t}</span>
          ))}
        </div>

        <div className="mt-10 flex gap-3 flex-wrap">
          {p.url && (
            <a href={p.url} target="_blank" rel="noreferrer" className="kb-btn-primary" data-testid="paper-detail-read-btn">
              <ExternalLink className="w-4 h-4" /> Read full text
            </a>
          )}
          <a href="#" className="kb-btn-outline" onClick={(e) => { e.preventDefault(); navigator.clipboard.writeText(`${p.authors.join(', ')} (${p.year}). ${p.title}. ${p.venue}. ${p.doi ? 'doi:' + p.doi : ''}`); }}>
            <Quote className="w-4 h-4" /> Copy citation
          </a>
        </div>
      </article>
      <Footer />
    </div>
  );
}
